import axios from 'axios';

const service = axios.create({
    baseURL: 'http://cartsee-website-backend.cartsee.com', // url = base url + request url
    // withCredentials: true, // 如跨域请求时要带上cookies,则设置为true
    timeout: 120000, // 请求超时时长
});

export async function getSing(params) {
    let err1;
    try {
        const response = service.get(`/wechat/getSign?url=${params}`);
        return response;
    } catch (err) {
        err1 = err;
    }
}